import { ChargingStationStatus } from "../models/chargingStationStatus";

export class StatusNotificationsDto {
  chargingStationId: string;

  connectorId: number;
  chargingStationName: string;

  statusId: number;
  status: ChargingStationStatus;
  displayStatus: string;

  info: string;
  vendorId: string;
  vendorErrorCode: string;
  timestampFromChargeBox: Date;
  timestampFromServer: Date;
  errorCode: string;

  customerId: number;
  customerName: string;

  getPrimaryKey() {
    return this.chargingStationId;
  }
}